interface IHeaderWidgetProps {
  text: string;
}

export interface IHeaderWidget {
  id: string;
  modalType: "text";
  type: "header";
  text: string;
}

const HeaderWidget = ({text}: IHeaderWidgetProps) => {
  return <div className="headerWidget">
    <h1 className="headerWidget-labelWrapper">{text}</h1>
  </div>;
};

export default HeaderWidget;